export default "__VITE_ASSET__310c6fe4__"